import React, { useEffect, useState, useMemo } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { setHeading } from "../../../accounts/account.actions";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import { GetConstructionOrderApi } from "../ConstructionOrder/ConstructionOrderAction";
import { AddConstructionOrderPaymentApi, GetConstructionOrderPaymentApi, resetConstructionOrderPaymentData } from "./ConstructionOrderPaymentAction";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import moment from "moment";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const AddConstructionOrderPayment = (props) => {
    const { t } = useTranslation();
    const [orderId, setOrderId] = useState("");
    const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
    const [payment, setPayment] = useState(0);
    const [paymentMode, setPaymentMode] = useState("Cash");
    const [description, setDescription] = useState("");


    const orderOptions = useMemo(() => {
        return isEmpty(props.constructionOrderDataList) ? [] : props.constructionOrderDataList.map((x) => ({
            value: x._id,
            label: `Order # ${x.sequenceNumber} - ${x.customerDetails?.name || ''}`,
            order: x,
        }));
    }, [props.constructionOrderDataList]);
    const selectedOrderOption = useMemo(() => {
        return orderOptions.find((opt) => opt.value === orderId) || null;
    }, [orderId, orderOptions]);
    const selectedOrder = selectedOrderOption?.order;

    const handleChangeOrder = (selectedOption) => {
        setOrderId(selectedOption.value);
        props.GetConstructionOrderPaymentApi(selectedOption.value);
    };


    const paymentModeOptions = [
        { value: "Cash", label: "Cash" },
        { value: "Bank", label: "Bank" },
        { value: "Cheque", label: "Cheque" },
    ];
    const handleChangePaymentMode = (selectedOption) => {
        setPaymentMode(selectedOption.value);
    };


    const orderAmount = Number(selectedOrder?.sellingPrice || 0);
    const totalReceived = Number(props.orderTotalReceived || 0);
    const remainingBalance = Math.round((orderAmount - totalReceived) * 100) / 100;


    function SaveConstructionOrderPayment() {
        props.AddConstructionOrderPaymentApi({
            orderId,
            date,
            payment: Number(payment),
            paymentMode,
            description,
        },
            showSuccessAlert,
            showErrorAlert
        );
        setOrderId("");
        setPayment(0);
        setPaymentMode("Cash");
        setDescription("");
        props.resetConstructionOrderPaymentData();
    }


    useEffect(() => {
        props.setHeading("Add Order Payment");
        props.GetConstructionOrderApi();
        props.resetConstructionOrderPaymentData();
    }, []);


    if (props.isAddingConstructionOrderPayment || props.isFetchingConstructionOrder) {
        return <GlobalSpinner />
    }

    return (
        <Container fluid>
            <Row>
                <Col>
                    <Form.Group className="mb-3" controlId="garana">
                        <Form.Label><b>{t("SelectOrder")} *</b></Form.Label>
                        <Select
                            isDisabled={isEmpty(orderOptions)}
                            value={selectedOrderOption}
                            placeholder="Select Order"
                            onChange={handleChangeOrder}
                            options={orderOptions}
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group className="mb-3" controlId="garana">
                        <Form.Label><b>{t("Date")} *</b></Form.Label>
                        <Form.Control
                            type="date"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Group className="mb-3" controlId="garana">
                        <Form.Label><b>Order Amount</b></Form.Label>
                        <Form.Control
                            value={isEmpty(orderId) ? '' : orderAmount}
                            disabled
                            type="text"
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group className="mb-3" controlId="garana">
                        <Form.Label><b>Total Received</b></Form.Label>
                        <Form.Control
                            value={isEmpty(orderId) ? '' : totalReceived}
                            disabled
                            type="text"
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group className="mb-3" controlId="garana">
                        <Form.Label><b>Remaining Balance</b></Form.Label>
                        <Form.Control
                            value={isEmpty(orderId) ? '' : remainingBalance}
                            disabled
                            type="text"
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Group className="mb-3" controlId="garana">
                        <Form.Label><b>Payment *</b></Form.Label>
                        <Form.Control
                            type="number"
                            onChange={(e) => setPayment(e.target.value)}
                            value={payment}
                            min={0}
                        />
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group className="mb-3" controlId="garana">
                        <Form.Label><b>Payment Mode *</b></Form.Label>
                        <Select
                            value={paymentModeOptions.find((opt) => opt.value === paymentMode) || null}
                            placeholder="Select Payment Mode"
                            onChange={handleChangePaymentMode}
                            options={paymentModeOptions}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Group className="mb-3" controlId="garana">
                        <Form.Label><b>Description</b></Form.Label>
                        <Form.Control
                            placeholder="Description"
                            as="textarea"
                            rows={2}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </Form.Group>
                </Col>
            </Row>

            <div className="sendDiv">
                <Button
                    variant="contained"
                    endIcon={<SendIcon />}
                    size="large"
                    disabled={isEmpty(orderId) || !date || !Number(payment)}
                    onClick={SaveConstructionOrderPayment}
                >
                    SAVE
                </Button>
            </div>

        </Container>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        AddConstructionOrderPaymentApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddConstructionOrderPaymentApi(data, showSuccessAlert, showErrorAlert)),
        GetConstructionOrderApi: () => dispatch(GetConstructionOrderApi()),
        GetConstructionOrderPaymentApi: (orderId) => dispatch(GetConstructionOrderPaymentApi(orderId)),
        resetConstructionOrderPaymentData: () => dispatch(resetConstructionOrderPaymentData()),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingConstructionOrderPayment: state.ConstructionOrderPaymentReducer.isAddingConstructionOrderPayment,
    orderTotalReceived: state.ConstructionOrderPaymentReducer.orderTotalReceived,
    isFetchingConstructionOrder: state.ConstructionOrderReducer.isFetchingConstructionOrder,
    constructionOrderDataList: state.ConstructionOrderReducer.constructionOrderDataList,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddConstructionOrderPayment);
